module.exports = __webpack_public_path__ + "static/media/Rainbow_thumb.5d362fee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/colours/Rainbow_thumb.jpg
// module id = 123
// module chunks = 0